import React from 'react';
import { useTheme } from '@24i/nxg-sdk-higgs';
import { Icon } from '@24i/nxg-sdk-quarks';
import { StyledButton } from '../../Button';
export const PrevNextEpisodeButton = ({ onPress, direction, disabled, playerInstance, }) => {
    var _a;
    const { theme } = useTheme();
    const iconToUse = direction === 'prev' ? theme.icons.player.previousEpisode : theme.icons.player.nextEpisode;
    const disabledColor = ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.contrast4) || 'gray';
    const iconColor = disabled ? disabledColor : theme.color.textPrimary;
    const onPressHandler = () => {
        if (disabled)
            return;
        onPress(direction);
    };
    const stopPropagation = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };
    return (React.createElement(StyledButton, { width: 24, heigth: 24, onClick: onPressHandler, onDoubleClick: stopPropagation, disabled: disabled, playerInstance: playerInstance, backgroundColor: "transparent" },
        React.createElement(Icon, { size: 24, name: iconToUse.iconName, font: iconToUse.iconFont, color: iconColor })));
};
//# sourceMappingURL=index.js.map